export default function VideosTableHeader() {
  return (
    <thead>
      <tr>
        <th className="table-th">Video Title</th>
        <th className="table-th">Description</th>
        <th className="table-th">Action</th>
      </tr>
    </thead>
  );
}
